//-----------------------------------------------------------------------------
//----- Copyright deersoft 2015 - 2019 www.deersoft.de
//-----------------------------------------------------------------------------
import { captureVoucherToken } from "@component/UserSettings/TrainingVouchers.utils";

captureVoucherToken();
